import { createSlice } from '@reduxjs/toolkit'

const currentDate = new Date().getTime()
const lastMonthDate = currentDate - 2592000000
export const partySlice = createSlice({
    name: 'parties',
    initialState: {
        parties: [],
        partyList:[],
        activeParty: null,
        ledgerFilter: {
            date_from: lastMonthDate,
            date_to: currentDate,
            party: false,
        },
        selectedParty:{
            name:"",
            firm:"",
            mobile:"",
            address:""
        },
        ledger:[],
        isLoading: false,
        reload: false
    },
    reducers: {
        getPartiesFetch: (state) => {
            state.isLoading = true;
        },
        getPartiesSuccess: (state, action) => {
            state.isLoading = false
            state.parties = action.payload
            state.partyList = action.payload.map(party=>party.name)
            state.reload = false
        },
        getPartiesFail: (state) => {
            state.isLoading = false
        },
        selectParty: (state,action)=>{
            state.activeParty = action.payload
            state.ledgerFilter.party= action.payload
        },
        setPartyObj: (state,action)=>{
            state.selectedParty = action.payload
        },
        setLedgerFilter: (state,action)=>{
            state.ledgerFilter.date_from =action.payload.date_from
            state.ledgerFilter.date_to = action.payload.date_to
        },
        resetLedgerFilter: (state)=>{
            state.ledgerFilter ={
                date_from: lastMonthDate,
                date_to: currentDate,
                party: state.activeParty,
            }
        },
        getPartiesLedgerFetch: (state) => {
            state.isLoading = true;
            state.ledger = []
        },
        getPartiesLedgerSuccess: (state, action) => {
            state.isLoading = false
            state.ledger = action.payload
            state.reload = false
        },
        getPartiesLedgerFail: (state) => {
            state.isLoading = false
        }
        

    }
})
export const selectParties = (state) => state.parties.parties
export const selectPartyList = (state) => state.parties.partyList
export const selectLedgerFilter = (state) => state.parties.ledgerFilter


export const selectPartiesIsLoading = (state) => state.parties.isLoading
export const selectActiveParty = (state) => state.parties.activeParty
export const selectPartyLedger = (state) => state.parties.ledger
export const selectSelectedParty = (state)=> state.parties.selectedParty
export const { getPartiesFetch, getPartiesSuccess, getPartiesFail,selectParty, getPartiesLedgerFetch, getPartiesLedgerSuccess, getPartiesLedgerFail, increaseLimit, reverseList,filterResult,setLedgerFilter,resetLedgerFilter,setPartyObj } = partySlice.actions;
export default partySlice.reducer